import { ImportMapper } from './ImportMapper.js';

class ImportRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  csv(params) {
    return this.apiClient.post('/v1/import/csv', ImportMapper.csvPayload(params)).then(response => response.data);
  }
  getUrl() {
    return this.apiClient.get('/v1/import/get_url').then(response => ImportMapper.createGetUrlModelFromResponse(response.data));
  }
  triggerFiveDayImportFromIntegration(params) {
    return this.apiClient.post(`/v1/import/${params.integration}`, ImportMapper.triggerFiveDayImportFromIntegrationPayload(params)).then(response => response.data);
  }
}

export { ImportRepository };
//# sourceMappingURL=ImportRepository.js.map
